import { render, staticRenderFns } from "./VsColor.vue?vue&type=template&id=0b27ccff&lang=html&"
import script from "./VsColor.vue?vue&type=script&lang=js&"
export * from "./VsColor.vue?vue&type=script&lang=js&"
import style0 from "./VsColor.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports